import styles from "./HorizontalProgressBar.module.css";

// width: filled bar width override (optional, in %)
// value: the raw value used to compute width if total is provided
// total: used with value to compute fill percentage
// color: CSS color string for the filled bar
// isLoading: shows shimmer when true
const HorizontalProgressBar = ({ value, total, color, isLoading, width }) => {
  const fillPercent =
    width != null
      ? width
      : total > 0
      ? Math.min((value / total) * 100, 100)
      : 0;

  if (isLoading) {
    return <div className={["shimmer", styles.track].join(" ")} />;
  }

  return (
    <div className={styles.track}>
      <div
        className={styles.fill}
        style={{
          "--fill-width": `${fillPercent}%`,
          backgroundColor: color,
        }}
      />
    </div>
  );
};

export default HorizontalProgressBar;